$ = require 'jquery'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
Util = require 'lib/util'
View = require 'views/internal/view'
_ = require 'underscore'
SearchInputTemplate = require 'views/templates/board_sidebar_search_input'
l = require 'lib/localize'

# This is only used in improvedBoardSearchFormFactor's
# searchInput variant. It's a more complex input box that
# is used in multiple board menu views.
#
# In the control and other variants, CardFilterView renders
# its own input box.
module.exports = class SearchInputView extends View
  className: 'board-menu-content-frame'

  initialize: ->
    @listenTo @model, 'change', @renderInputIcon

  events:
    'keyup .js-input': 'keyUpEvent'
    'keydown .js-input': 'keyDownEvent'
    'click .js-search-clear-title': 'clearAndFocusInput'
    'click .js-search-open-card-filter': 'showCardFilter'

  render: ->
    @$el.html(SearchInputTemplate.renderInputRow({
      title: @model.get('title')
      showFilterButton: @options?.showCardFilter?
    }))

    @renderInputIcon()

    @

  renderInputIcon: ->
    @$('.js-input-search-icon').html(SearchInputTemplate.renderInputIcon({
      title: @model.get('title')
    }))

  keyUpEvent: (e) ->
    # esc will remove the input value and subsequently the search
    # title from filter array if selected, so just return if esc
    # is hit (will close the popover like normal)
    key = Keyboard.getKey(e)
    return if key in [Keys.Escape, Keys.Enter, Keys.ArrowUp, Keys.ArrowDown]

    @model.save({
      title: @$('.js-input').val()
      limitMembers: true
      limitLabels: true
    })

  keyDownEvent: (e) ->
    key = Keyboard.getKey(e)
    if key == Keys.Enter
      @showCardFilter()

  clearAndFocusInput: ->
    @model.save({ title: "" })
    @$('.js-input').val("").focus()

  showCardFilter: ->
    @options?.showCardFilter?()



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/search-input-view.coffee